import { ApiResponse } from '../../../../../types/api-response.types';
import { FilterItem } from '../../../../../types/filters.types';

export enum JobStatusEnum {
  PENDING = 'pending',
  RUNNING = 'running',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export type StatusInfo = {
  id: string;
  code: string;
  description: string;
};

export type Job = {
  id: string;
  tenantId: string;
  createdBy: {
    id: string;
    name: string;
    email: string;
  };
  jobName: string;
  failed: number;
  total: number;
  success: number;
  dataIds: string[];
  status: JobStatusEnum;
  triggerStatus?: StatusInfo;
  successStatus?: StatusInfo;
  failedBotStatus?: StatusInfo;
  failedDataStatus?: StatusInfo;
  triggerStatusId?: string;
  successStatusId?: string;
  failedBotStatusId?: string;
  failedDataStatusId?: string;
  workflowId?: string;
  email?: string;
  link?: string;
  isTemplate?: boolean;
  isDeleted?: boolean;
  deletedAt?: Date;
  createdAt?: Date;
  updatedAt?: Date;
};

export interface JobGetResponse extends ApiResponse<Job> {
  data: Job;
}

export interface JobGetFiltersResponse {
  data: FilterItem[];
}

export type JobList = Job[];

export type JobCreatePayload = {
  jobName: string;
  workflowId: string;
  dataIds: string[];
  triggerStatusId: string;
  successStatusId?: string;
  failedBotStatusId?: string;
  failedDataStatusId?: string;
  failed?: number;
  total?: number;
  success?: number;
  status?: JobStatusEnum;
  templateId?: string;
  isTemplate?: boolean;
  link?: string;
  email?: string;
};

export type JobUpdatePayload = {
  jobName?: string;
  workflowId?: string;
  dataIds?: string[];
  triggerStatusId?: string;
  successStatusId?: string;
  failedBotStatusId?: string;
  failedDataStatusId?: string;
  failed?: number;
  total?: number;
  success?: number;
  status?: JobStatusEnum;
  link?: string;
  email?: string;
};
